
export const urlSourceList = '/api/XOrg/BookMaterial/getsourcelist';
export const urlPartnerSource = '/api/XOrg/BookMaterial/GetPartnerSource';
export const urlSchoolSource = '/api/XOrg/PartnerShareSource/GetSchoolSource';
export const urlGetSourceByTeaId = '/api/XOrg/BookMaterial/GetSourceByTeaId';
export const urlSaveFolder = '/api/XOrg/BookMaterial/saveFolder';
import http from 'lib/http';
import { RequestResult } from './v1.XOrg.courseteacher';
export const urldelCourseWare = '/api/XOrg/BookMaterial/delCourseWare';
export const urlupdateCourseWare = '/api/XOrg/BookMaterial/updateCourseWare';
export const urldelallCourseWare = '/api/XOrg/BookMaterial/delallCourseWare';
export const urlmoveFolder = '/api/XOrg/BookMaterial/moveFolder';
export const urlgetFolderId = '/api/XOrg/BookMaterial/getFolderId';
export const urlgetStuList = '/api/XOrg/BookMaterial/getClassStu';
export const urlAddCourseScourse = '/api/XOrg/BookMaterial/AddCourseScourse';
export const urlAddLabels = '/api/XOrg/BookMaterial/addLabels';

export interface ISourceList {
  code: number;
  list: {
    CourseWareName: string;
    CourseWareType: string;
    CreateUserId: string;
    DateCreated: string;
    DocExtension: string;
    DocSize: string;
    ConvertStatus: number;
    DocUrl: string;
    DocPrexUrl: string;
    Id: string;
    Keyword: {}[];
    MediaType: number;
    Language: string;
    Source: string;
    Author: string;
    Company: string;
    ContactInformation: string;
  }[];
  msg: string;
  FolderId: string;
  pagination: {
    pageIndex: number;
    pageSize: number;
    totalCount: number;
  };
  courseId: string;
  courseName: string;
  nodePathList: {
    Id: string,
    nodeName: string
  }[];
  dataCount: number;
  myid: string;
  otherid: string;
}

export function moveFolder(ids: string[], fId: string) {
  return http.post<ISourceList>(urlmoveFolder, {
    ids,
    fId
  });
}
export interface IFolder {
  code: number;
  list: {
    Id: string;
    ParentId: string;
    NodePath: string;
    FolderName: string;
  }[];
}
export function getFolderId(courseId: string) {
  return http.post<IFolder>(urlgetFolderId, {
      courseId
  }).then((rst) => {
    let folder = {};
    let resultFolder = <any>[];
    if (rst.list && rst.list.length) {

      folder = {};
      rst.list.forEach(el => {
        // el.NodePath
        if (el.ParentId === '0') {
          folder[el.Id] = folder[el.Id] || {
            id: el.Id,
            children: []
          };
          folder[el.Id]['label'] = el.FolderName;
          resultFolder.push(folder[el.Id]);
        } else {
          if (el.NodePath && el.NodePath.length) {
            let paths = el.NodePath.split('/');
            let pathsLen = paths.length - 1;
            for (let i = 0; i <= pathsLen; i++) {
              let path = paths[i];

              if (i !== pathsLen) {
                folder[path] = folder[path] || {
                  id: path,
                  children: []
                };
              } else {
                folder[path] = folder[path] || {
                  id: el.Id
                };
                folder[path]['label'] = el.FolderName;

                let parent = folder[el.ParentId];
                if (parent && !parent.children) {
                  parent['children'] = [];
                }
                folder[el.ParentId].children.push(folder[path]);
              }
              folder[el.ParentId] = folder[el.ParentId] || {
                id: el.ParentId,
                children: []
              };
            }
          }
        }
      });
    }
    console.log(resultFolder);
    return resultFolder;
  });
}

export function GetPartnerSource(CreatedSchoolId: string, folderId?: string, page?: number, SchoolCourseId?: string) {
  return http.get<ISourceList>(urlPartnerSource, {
    params: {
      CreatedSchoolId,
      folderId,
      page,
      SchoolCourseId
    }
  });
}

export function GetSchoolSource( folderId?: string, page?: number, SchoolCourseTypeId?: string) {
  return http.get<ISourceList>(urlSchoolSource, {
    params: {
      folderId,
      page,
      SchoolCourseTypeId
    }
  });
}

export function GetSourceByTeaId( IsPartner: number, CourseId: string, folderId?: string, page?: number, SchoolCourseTypeId?: string) {
  return http.get<ISourceList>(urlGetSourceByTeaId, {
    params: {
      IsPartner,
      CourseId,
      folderId,
      page,
      SchoolCourseTypeId
    }
  });
}

export function NewGetSourceList(courseId?: string, folderId?: string, type?: string,sort?: string, page?: number, pageSize?: number) {
  return http.get<ISourceList>(urlSourceList, {
    params: {
      courseId,
      folderId,
      type,
      sort,
      page,
      pageSize
    }
  });
}
export function GetSourceList(courseId?: string, folderId?: string, type?: string, page?: number, pageSize?: number) {
  return http.get<ISourceList>(urlSourceList, {
    params: {
      courseId,
      folderId,
      type,
      page,
      pageSize
    }
  });
}

export interface ICourseInfo {
  code: number;
  status: number;
  docPriviewUrl: string;
  docType: number;
  docName: string;
  type: string;
}
export const urlSourceInfo = '/api/XOrg/BookMaterial/getNewCourseWareInfo';
export function GetSourceInfo(coursewareid: string) {
  return http.get<ICourseInfo>(urlSourceInfo, {
    params: {
      coursewareid
    }
  });
}

export function saveFolder(folderName: string, courseId: String, courseName: String, folderId: String) {
  return http.post<RequestResult>(urlSaveFolder, {
    folderName: folderName,
    courseId: courseId,
    courseName: courseName,
    folderId: folderId
  });
}

export function UpdateCourseWare(id: string, courseWareName: string, txtsourceUrl: string) {
  return http.get<ISourceList>(urlupdateCourseWare, {
    params: {
      id,
      courseWareName,
      txtsourceUrl
    }
  });
}

export function DelCourseWare(id: string) {
  return http.post<ISourceList>(urldelCourseWare, {
    id
  });
}

export function delallCourseWare(ids: string[]) {
      return http.post<ISourceList>(urldelallCourseWare, {
        ids
      });
}

export interface IstuList {
  stuList: string;
}

export function getStuList(classId: string) {
  return http.post<IstuList>(urlgetStuList, {
    classId
  });
}

export interface Irespones {
  code: number;
  msg: string;
}

export function AddCourseScourse(ids: string[], courseId: string, folderId: string, schoolId: string) {
  return http.post<Irespones>(urlAddCourseScourse, {
    ids,
    courseId,
    folderId,
    schoolId
  });
}

export function addLabels(
  id: string,
  keyword: string,
  mediaType: number,
  language: number,
  sourceone: number,
  author: string,
  company: string,
  contactInformation: string
) {
  return http.post<Irespones>(urlAddLabels, {
    id,
    keyword,
    mediaType,
    language,
    sourceone,
    author,
    company,
    contactInformation
  });
}
